import React, { useState, useEffect } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Alert,
  Chip,
} from '@mui/material';
import axios from 'axios';
import { API_URL } from '../../../config/api';
import { useAuth } from '../../../context/AuthContext';

const EmployeeSelector = ({ selectedEmployee, onEmployeeChange }) => {
  const { getAuthHeaders } = useAuth();
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${API_URL}/admin-onboarding-steps/employees-with-progress`,
        { headers: getAuthHeaders() }
      );
      setEmployees(response.data);
    } catch (err) {
      setError('Failed to fetch employees');
      console.error('Error fetching employees:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleEmployeeChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue) {
      // Find the selected employee to get both IDs
      const selectedEmployeeData = employees.find(emp => emp._id === selectedValue);
      if (selectedEmployeeData) {
        // Pass both employeeId and userId (handle null userId)
        onEmployeeChange({
          employeeId: selectedEmployeeData._id,
          userId: selectedEmployeeData.userId || null,
          employeeData: selectedEmployeeData
        });
      }
    } else {
      // If no employee selected, pass null
      onEmployeeChange(null);
    }
  };

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
        Onboarding Activities
      </Typography>
      <FormControl fullWidth sx={{ mt: 2 }}>
        <InputLabel id="employee-select-label">Select Employee</InputLabel>
        <Select
          labelId="employee-select-label"
          id="employee-select"
          value={selectedEmployee?.employeeId || ''}
          label="Select Employee"
          onChange={handleEmployeeChange}
          disabled={loading}
        >
          <MenuItem value="">
            <em>Choose an employee</em>
          </MenuItem>
          {employees.map((employee) => (
            <MenuItem key={employee._id} value={employee._id}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                <Box>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {employee.firstName} - {employee.email}
                  </Typography>
                  {/* <Typography variant="caption" color="text.secondary">
                    Employee ID: {employee._id} | User ID: {employee.userId || 'Not Assigned'}
                  </Typography> */}
                </Box>
                <Chip 
                  label={`${employee.progress?.completedSteps || 0}/${employee.progress?.totalSteps || 10}`}
                  size="small"
                  color={employee.progress?.completedSteps === employee.progress?.totalSteps ? "success" : "default"}
                  variant="outlined"
                />
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default EmployeeSelector; 